import styled from 'styled-components';

import Input from '@components/Input';

export const MultiSelectionFilterWrapper = styled.div`
  user-select: none;
  border-radius: 8px;
  overflow: hidden;
`;

export const Title = styled.h3`
  display: flex;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};

  & span {
    font-weight: normal;
    padding-left: 2px;
  }
`;

export const MultiSelectionItemsWrapper = styled.div<{
  isShowMore?: boolean;
}>`
  ::-webkit-scrollbar {
    width: 5px;
    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
  margin-top: 10px;

  & > div:not(:last-child) {
    margin-bottom: 3px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px 15px 0px 15px;
    margin: 0px;
  }
  max-height: ${({ isShowMore }) => (isShowMore ? '430px' : '220px')};
  overflow-y: auto;
  margin-bottom: 8px;
`;

export const MultiSelectionItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 15px !important;
  height: 40px;
  max-height: 40px;
  padding: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-left: 0px;
    padding-top: 10px;
    padding-bottom: 4px;
    padding-right: 0px;
  }
`;

export const CollapseHeaderSubTitleStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;

export const ExtraFieldValueStyle = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  margin-right: 3px;
  text-align: end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-right: 0px;
  }
`;

export const SubTitle = styled.span`
  font-size: 14px;
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.NL300};
  font-weight: 400;
`;

export const CheckboxLabel = styled.h4`
  word-break: break-word;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.NL800};
  font-weight: 400;
  margin-left: 3px;
`;

export const PriceWrapper = styled.div`
  font-size: 14px;
  text-align: center;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;

export const ShowMoreWrapper = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.B400};
  margin-left: 10px;
  cursor: pointer;
`;

export const SearchInFiltersInput = styled(Input)`
  width: 100%;
  height: 100% !important;
  padding: 0;
  border-color: transparent;
  outline: none;
  font-size: 16px;
  font-weight: 400;
  caret-color: ${({ theme }) => theme.palette.NL500};
  color: ${({ theme }) => theme.palette.NL500};
  background-color: ${({ theme }) => theme.palette.NL10};
  border: none;
  &:focus-within,
  &:focus {
    border: none !important;
    outline: 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    background-color: ${({ theme }) => theme.palette.NL10} !important;
  }
`;

export const NameFilterInputWrapper = styled.div`
  width: 100%;
  height: 44px;
  padding: 0 10px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL10};

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border: solid 1px ${({ theme }) => theme.palette.inputBorderColor};

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 20px;
    background-color: ${({ theme }) => theme.palette.NL10};
  }
`;

export const ResponsiveNameFilterInputWrapper = styled.div`
  width: calc(100% - 8px);
  margin-left: 4px;
  margin-right: 4px;
  height: 44px;
  padding: 0 10px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border: solid 1px ${({ theme }) => theme.palette.inputBorderColor};

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 20px;
    background-color: ${({ theme }) => theme.palette.NL10} !important;
  }
`;

export const CollapsableNameFilterInputWrapper = styled(NameFilterInputWrapper)`
  margin-top: 15px;
`;

export const ResponsiveCollapsableNameFilterInputWrapper = styled(
  ResponsiveNameFilterInputWrapper
)`
  padding-left: 4px;
  padding-right: 4px;
`;
